import styled, {createGlobalStyle, css} from 'styled-components';

const LAUNCHER_SIZE = '60px';
const GAP = '12px';
const RIGHT = '16px';
const BOTTOM = '16px';

export const FLOATING_STACK_BOTTOM = `calc(${BOTTOM} + (${LAUNCHER_SIZE} + ${GAP}) * 2)`;

// The `body` prefix outranks HubSpot's own later-injected
// `#hubspot-messages-iframe-container { display: initial !important }`.
export const ChatStacking = createGlobalStyle`
  body #hubspot-messages-iframe-container {
    z-index: 1298 !important;
    ${({$hideChat}) => $hideChat && 'display: none !important;'}
  }
`;

const beside = css`
  right: calc(${RIGHT} + ${LAUNCHER_SIZE} + ${GAP});
  bottom: ${BOTTOM};
`;

const alone = css`
  bottom: ${BOTTOM};
`;

// Kept just below MUI's default theme.zIndex.modal (1300, used by
// Dialog/Menu/Select/Popover alike — node_modules/@material-ui/core/Modal/
// Modal.js:62 — and matched by this app's own custom dropdowns, e.g.
// discountsV2/styles/DiscountsHeader.js), so the button stays above the
// HubSpot widget (kept one step below via ChatStacking) without covering
// app menus/dialogs. Dialogs are handled separately: while one is open the
// button is not rendered and ChatStacking hides the HubSpot widget too.
const WhatsAppSupportLink = styled.a`
  position: fixed;
  right: ${RIGHT};
  bottom: calc(${BOTTOM} + ${LAUNCHER_SIZE} + ${GAP});
  z-index: 1299;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${LAUNCHER_SIZE};
  height: ${LAUNCHER_SIZE};
  border-radius: 50%;
  background-color: #ffffff;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.16);
  text-decoration: none;
  cursor: pointer;

  ${({$mode}) => $mode === 'beside' && beside};
  ${({$mode}) => $mode === 'alone' && alone};

  &:hover {
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.22);
  }

  &:focus-visible {
    outline: 2px solid #25d366;
    outline-offset: 3px;
  }

  @media (prefers-reduced-motion: no-preference) {
    transition: transform 100ms ease-in-out;

    &:hover {
      transform: scale(1.1);
    }
  }

  svg {
    display: block;
    flex: 0 0 auto;
    width: 28px;
    height: 28px;
  }
`;

export default WhatsAppSupportLink;
